import HttpRequest from '@/libs/axios';
import config from '@/config';

let baseUrl = config.baseUrl;
let fileServerUrl = config.fileServerUrl;

const axios = new HttpRequest(baseUrl, fileServerUrl);
export default axios;
